const  conditionalevel = [
    "Did you take Math (of 100 Marks) ?",
    "Did you take Physics ( of 100 Marks) ?",
    "Did you score a minimum of grade D (overall) (with or without small letter) ?"
  ];
  export default conditionalevel;